import http from './httpService';
import config from './../config.json';

const address = config.api_address + config.api_user;


export const getAllUsers = (params, {signal}) => {
	return http.get(`${address}/get-users`, {signal, params});
}

export const getUsersForReport = (params, {signal}) => {
	return http.get(`${address}/get-users-for-report`, {signal, params});
}

export const getHomePageInfo = ({signal}) => {
	return http.get(`${address}/homePage`, {signal});
}

export const getSMSAccountInfo = ({signal}) => {
	return http.get(`${address}/smsAccountInfo`, {signal});
}

export const sendMobileNumber = (mobile) => {
	return http.get(`${address}/sending-mobile/${mobile}`);
}

export const sendVerificationCode = (info) => {
	return http.get(`${address}/sending-vcode/${info.mobile}/${info.vcode}`);
}

export const userRegister = (user) => {
    return http.post(`${address}/register`, JSON.stringify(user));
}

export const updateUserInfo= (info) => {
	return http.patch(`${address}/update-user-info`, info);
}
export const updateManagerInfo= (info) => {
	return http.patch(`${address}/update-manager-info`, info);
}

export const updateManagerUserName= (info) => {
	return http.patch(`${address}/update-manager-user-name`, info);
}

export const updateManagerUserAddress= (info) => {
	return http.patch(`${address}/update-manager-user-address`, info);
}

export const updateUserColor= (info) => {
	return http.patch(`${address}/update-user-color`, info);
}
export const updateUserStatus= (info) => {
	return http.patch(`${address}/update-user-status`, info);
}
export const updateAdminStatus= (info) => {
	return http.patch(`${address}/update-admin-status`, info);
}

export const userLogout = () => {
	return http.delete(`${address}/logout`);
}

// export const deleteUserById = (_id) => {
// 	return http.delete(`${address}/remove/${_id}`)
// }

export const authToken = ({signal}) => {
	return http.get(`${address}/auth-token`, {signal});
}

export const getAllDocumentsCount = ({signal}) => {
    return http.get(`${address}/all-documents-count`, {signal});
    
}
